import React, { useState, useLayoutEffect, useEffect } from "react";
import "../styles/components/Datepicker.scss";
import ValidationError from "./ValidationError";
// import DatePicker from "react-date-picker";
import { DatePicker } from "@els/els-react--date-picker";
import { Trans, useTranslation } from "react-i18next";

const Datepicker = (props: any) => {
  const dt = new Date();
  const minDt = new Date(1850, 1, 1);
  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState(props?.value);

  useEffect(() => {
    setStartDate(props?.value);
  }, [props?.value]);

  useLayoutEffect(() => {
    document
      .querySelector("div.datepicker input")
      ?.setAttribute("placeholder", "DD/MM/YYYY");
  }, []);

  const intlMsgs = {
    CHOOSE_DATE: t("datepicker.choose_date"),
    CHOOSE_DATE_FULL: t("datepicker.choose_date_full"),
    ERROR_FORMAT: t("datepicker.error_format"),
    ERROR_MAX_YEAR: t("datepicker.error_max_year"),
    ERROR_MIN_YEAR: t("datepicker.error_min_year"),
    NEXT_MONTH: t("datepicker.next_month"),
    PREV_MONTH: t("datepicker.prev_month"),
    SUNDAY: t("datepicker.sunday"),
    MONDAY: t("datepicker.monday"),
    TUESDAY: t("datepicker.tuesday"),
    WEDNESDAY: t("datepicker.wednesday"),
    THURSDAY: t("datepicker.thursday"),
    FRIDAY: t("datepicker.friday"),
    SATURDAY: t("datepicker.saturday"),
    JANUARY: t("datepicker.january"),
    FEBRUARY: t("datepicker.february"),
    MARCH: t("datepicker.march"),
    APRIL: t("datepicker.april"),
    MAY: t("datepicker.may"),
    JUNE: t("datepicker.june"),
    JULY: t("datepicker.july"),
    AUGUST: t("datepicker.august"),
    SEPTEMBER: t("datepicker.september"),
    OCTOBER: t("datepicker.october"),
    NOVEMBER: t("datepicker.november"),
    DECEMBER: t("datepicker.december"),
  };
  let lastDateInput = "";

  const dateFormatCheck = (e: any) => {
    if (e.target.value.length <= 11) {
      if (/^[\/0-9]+\/?\/?$/gi.exec(e.target.value)) {
        lastDateInput = e.target.value;
      } else {
        e.target.value = e.target.value.length === 0 || 1 ? "" : lastDateInput;
      }
    } else {
      e.target.value = lastDateInput;
    }
  };

  return (
    <div className="datepicker">
      <label className="label-1">
        {props?.label_key ? (
          <>
            <Trans i18nKey={props?.label_key}></Trans>{" "}
            {props.mandate && <span className="mandetory">*</span>}
          </>
        ) : (
          props.label
        )}
      </label>

      {startDate ? (
        <>
          <div>
            <DatePicker
              handleDateChange={function (e: any) {
                props?.onChange(e);
              }}
              dateFormat="dd/MM/yyyy"
              dateFormatDescription="" //left intentionally blank due to the error message appending this attribute to the message
              validator={function (e: any) {
                /*
                TODO: this validation should move to parent function
                remove ignoreDatePickerValidation, props?.onError() its workaround
                */
                if (props?.ignoreValidation) {
                  props?.onError();
                } else {
                  return e.getTime() > new Date().getTime()
                    ? t("error.invalid_birthdate")
                    : "";
                }
              }}
              startDate={startDate}
              minYear={
                props?.minDt
                  ? new Date(props.minDt).getFullYear()
                  : minDt.getFullYear()
              }
              maxYear={dt.getFullYear()}
              messages={intlMsgs}
              className={props.className ?? ""}
              onInputKeyUp={function (e: any) {
                dateFormatCheck(e);
              }}
            />
          </div>
        </>
      ) : (
        <>
          <DatePicker
            handleDateChange={function (e: any) {
              props?.onChange(e);
            }}
            dateFormat="dd/MM/yyyy"
            dateFormatDescription="" //left intentionally blank due to the error message appending this attribute to the message
            startBlank={true}
            validator={function (e: any) {
              /*
                TODO: this validation should move to parent function
                remove ignoreDatePickerValidation, props?.onError() its workaround
                */
              if (props?.ignoreValidation) {
                props?.onError();
              } else {
                return e.getTime() > new Date().getTime()
                  ? t("error.invalid_birthdate")
                  : "";
              }
            }}
            minYear={
              props?.minDt
                ? new Date(props.minDt).getFullYear()
                : minDt.getFullYear()
            }
            messages={intlMsgs}
            maxYear={dt.getFullYear()}
            className={props.className ?? ""}
            onInputKeyUp={(e: any) => {
              dateFormatCheck(e);
            }}
          />
        </>
      )}

      {/*old Datepicker
      
      <DatePicker
        format={"dd-MM-yyyy"}
        dayPlaceholder={"dd"}
        monthPlaceholder={"mm"}
        yearPlaceholder={"yyyy"}
        openCalendarOnFocus={false}
        maxDate={dt}
        minDate={props?.minDt ? props.minDt : minDt} // takes in props from the BasicPatientDetails component to set the minimum year to 100 years less than the present year
        value={props?.value || null}
        onChange={props?.onChange}
        data-testid={props.testId}
      />
      /> */}
      <ValidationError error_key={props?.error} />
    </div>
  );
};

export default Datepicker;
